import type { IDayPartValue } from '@pushly/aqe/lib/components'

export function buildAllowedDayMap(days: string[]): IDayPartValue {
  const map: any = {}
  days.filter((d) => !!d).forEach((d) => {
    map[d] = true
  })
  return map as IDayPartValue
}
